<template>
  <section class="home-mobile">
    <div v-if="!select_load_day && !choose_date" class="infinite-wrap">
      <unloading-filter-bids
        :load-point="load_point"
        @input="onInput"
        @fetch="fetchBidsByRoutes"
      />
      <el-collapse-transition>
        <bids-mobile
          v-if="getTypeView"
          :freights="freightTypesObj"
          :bids="bidsList"
          :page="page"
          @page="changePage"
          @next="loadDay"
          @fetch="fetchBids"
          @load="loadDayInfo"
        />
      </el-collapse-transition>
      <el-collapse-transition>
        <bids-map-one-request
          v-if="!getTypeView"
          :freights="freightTypesObj"
          :bids="bidsList"
          @next="loadDay"
        />
      </el-collapse-transition>
    </div>
    <el-collapse-transition>
      <choose-day-mobile
        v-if="choose_date"
        :days="checkDates()"
        @next="loadDayInfo"
        @back="loadDay()"
      />
    </el-collapse-transition>
    <el-collapse-transition>
      <load-day-mobile
        v-if="select_load_day"
        :bid="bid"
        :day="choosedDay(choosed_day)"
        :freights="freightTypesObj"
        @load="loadDayInfo"
      />
    </el-collapse-transition>
  </section>
</template>

<script>
import { isFutures } from '@/helpers/functions'
import { mapActions, mapGetters } from 'vuex'
import BidsMapOneRequest from '@/components/Maps/BidsMapOneRequest'
import BidsMobile from './components/BidsMobile'
import ChooseDayMobile from './components/ChooseDayMobile'
import LoadDayMobile from './components/LoadDayMobile/index'
import UnloadingFilterBids from './components/UnloadingFilterBids'

export default {
  name: 'HomeMobile',
  components: {
    BidsMobile,
    ChooseDayMobile,
    LoadDayMobile,
    UnloadingFilterBids,
    BidsMapOneRequest,
  },
  data() {
    return {
      bid: {},
      choosed_day: null,
      select_load_day: false,
      choose_date: false,
      load_point: '',
      perPage: 50,
      page: 1,
    }
  },
  computed: {
    ...mapGetters({
      getLibObj: 'libs/getLibObj',
      getType: 'bids/getTypeCode',
      bids: 'bids/getBids',
      getTypeView: 'bids/getTypeView',
      getUnloadPointKladrId: 'bids/getUnloadPointKladrId',
    }),
    freightTypesObj() {
      return this.getLibObj('freightTypes')
    },
    bidsList() {
      let sort = false
      const driverBids = []
      const filledBids = this.bids.filter(b => {
        let entries = []
        const future_days = b.load_days
          ?.filter(day => isFutures(day.load_date))
          ?.map((d, i) => {
            d.index = i

            if (this.isDriverRole) {
              const arr = d.responses?.map(r => ({
                ...r,
                date: d.load_date,
                index: i,
              }))

              if (arr?.length > 0) {
                entries = entries.concat(arr)
                sort = true
              }
            }

            return d
          })

        if (future_days.length > 0) {
          b.future_days = future_days
          driverBids.push({ ...b, entries })
        }

        return future_days.length > 0
      })

      return this.isDriverRole && sort
        ? driverBids.sort(this.sorting)
        : filledBids
    },
  },
  watch: {
    getTypeView: {
      immediate: true,
      handler() {
        this.page = 1
        this.fetchBids()
      },
    },
    getType() {
      this.page = 1
      this.fetchBids()
    },
    getUnloadPointKladrId() {
      this.page = 1
      this.fetchBids()
    },
  },
  created() {
    this.fetchBidsKladrs()
  },
  methods: {
    ...mapActions('bids', ['fetchBidsKladrs']),
    fetchBids(requestData = {}) {
      const data = {
        type_code: this.getType,
        load_point: this.load_point,
        unload_point_kladr_id: this.getUnloadPointKladrId,
        ...requestData,
      }

      if (this.isDriverRole) {
        data.future_days = 1
        data.day_status = 0
      }

      if (this.getTypeView) {
        data.page = this.page
        data['per-page'] = this.perPage
      } else {
        data.enablePages = 0
      }
      this.$emit('fetch', data)
    },
    fetchBidsByRoutes() {
      this.page = 1
      this.fetchBids()
    },
    sorting(a, b) {
      return (a.entries && !b.entries) || a.order > b.order ? -1 : 1
    },
    changePage(page) {
      this.page = page
      this.fetchBids()
    },
    choosedDay(chooseDay) {
      return this.checkDates()[chooseDay]
    },
    loadDay(bid) {
      this.bid = bid || {}
      this.choose_date = Boolean(bid)
      this.choosed_day = null
    },
    loadDayInfo(flag = false, day = null, bid = null) {
      this.select_load_day = flag
      this.choose_date = false
      this.choosed_day = day

      if (bid) {
        this.bid = bid
      }
    },
    checkDates() {
      return this.bid?.future_days || []
    },
    onInput(val) {
      this.load_point = val
    },
  },
}
</script>

<style lang="sass">
@import "~@/assets/styles/mixins.sass"

.home-mobile
  min-width: 320px
  font-size: 11.5px
  line-height: normal
  color: #000000
  margin: 0
  @include from(360px)
    font-size: 13px
  @include from(400px)
    font-size: 14px
  @include from(500px)
    font-size: 16px
  .infinite-wrap
    height: calc(100vh - 50px)
    overflow: auto
  .el-table::before
    height: 0
  p
    margin: 0
  .err-p
    color: #ff0000
    font-size: 16px
    margin: 15px
  .mb-5
    margin-bottom: 5px
  .mob-btn
    width: 165px
    height: 30px
    font-weight: bold
    font-size: 12px
    padding: 0
    border-radius: 5px
    @include from(360px)
      width: 175px
    @include from(400px)
      width: 190px
      font-size: 13px
    @include from(420px)
      width: 200px
      font-size: 13px
    @include from(500px)
      height: 40px
      font-size: 14px
    &.el-button + .el-button
      margin: 0 15px 15px
    &.ld-btn
      width: 285px
      margin-bottom: 15px
    &.map-btn
      width: 75px
      font-size: 13px
      @include from(360px)
        width: 95px
      @include from(400px)
        width: 100px
        font-size: 14px
    &.change-btn
      width: 105px
    &.del-btn
      width: 135px
      background: #FF0000
  .map-el-dialog
    .el-dialog__body
      padding: 0 0 20px

  .bid
    font-family: 'Rubik', sans-serif
    background: #F9FDFF
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25)
    padding: 15px
    margin-bottom: 25px
    @include from(360px)
      padding-right: 25px
    @include from(400px)
      padding: 15px 25px
    .arrow-btn
      width: 30px
      height: 30px
      font-size: 25px
      padding: 0
      @include from(500px)
        width: 40px
        height: 40px
        font-size: 35px
    &.el-card
      color: #000000
    .el-card__body
      padding: 0
    .img-block
      height: 90px
      display: flex
      flex-direction: column
      align-items: center
      .arrow
        width: 18px
        height: 25px
        background: url('~@/assets/img/bid-arrow.png')
        background-size: contain
      .dots
        width: 2px
        height: 40px
        background: url('~@/assets/img/dots.svg') no-repeat
        background-size: contain
        margin: 5px 0
      .circle
        width: 12px
        height: 12px
        background: #FFFFFF
        border: 2px solid #2D9CDB
        box-sizing: border-box
        border-radius: 50%
    .direction
      padding-left: 20px
      font-size: 19px
      margin-bottom: 20px
      @include from(400px)
        font-size: 21px
      .from
        font-size: 12px
        @include from(360px)
          font-size: 13px
        @include from(400px)
          font-size: 14px
      .to
        font-size: 12px
        color: #B5B5B5
        @include from(400px)
          font-size: 13px
      .el-divider
        background-color: #00B754
      .el-divider--horizontal
        margin: 15px 0
      .el-divider__text
        font-size: 13px
        background-color: #F9FDFF
        padding: 10px
        @include from(400px)
          font-size: 14px
    .day-info
      margin-bottom: 25px
      .current
        color: #67C23A
        font-size: 10.5px
        @include from(360px)
          font-size: 12px
        @include from(400px)
          font-size: 13px
        @include from(500px)
          font-size: 16px
      .subscribe
        p, b span
          font-size: 11px
          @include from(360px)
            font-size: 12px
          @include from(400px)
            font-size: 14px
        text-align: right
        margin-top: -8px
        @include from(360px)
          margin-top: -7px
        @include from(400px)
          margin-top: -9px
        @include from(500px)
          margin-top: -8px
        .price-vip
          display: block
          font-size: 16px
          color: #00B754
          padding-left: 7px
          span
            font-size: 12px
          br
            display: block
          @include from(400px)
            font-size: 20px
          @include from(450px)
            font-size: 20px
            br
              display: none
            span
              font-size: 14px
        .price
          font-size: 16px
          color: #616161
          padding-left: 10px
          @include from(400px)
            font-size: 20px
    .entries-block
      margin-bottom: 25px
      .entry-row
        margin-bottom: 15px
      b + b
        margin-left: 15px
        font-weight: 500
    .btn-block
      margin-bottom: 15px
    .bid-el-link
      margin-left: 5px
  .info-block
    margin-bottom: 30px
    text-align: center
    p
      font-size: 12px
      @include from(360px)
        font-size: 14px
      @include from(400px)
        font-size: 16px
    p:last-child
      margin-top: 15px
  .choosed
    max-width: 400px
    margin: 0 auto
    text-align: center
    .el-select
      margin: 15px 0
    p
      font-size: 18px
  .el-table__empty-text
    line-height: normal
  .middle-section
    padding: 0 10px 20px 20px
    .response
      cursor: pointer
      margin-bottom: 25px
      line-height: 20px
      @include from(360px)
        line-height: 22px
      @include from(400px)
        line-height: 24px
      @include from(500px)
        line-height: 28px
    p
      margin-bottom: 15px
  .dp_green
    color: #67C23A
  .dp_red
    color: #FF0000
  .el-button+.el-button
    margin: 5px 15px
  .section-load-day
    .closed
      color: #ff0000
      margin: 10px
  .loader
    height: 25vh
    color: #409EFF
</style>
